import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "../montacargas.css";

// Cada vista pinta su propio encabezado (hero en login, navbar en home),
// igual que amcmontacargas-L8.8, así que el layout solo aporta el shell.
function MontacargasLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleForceLogout = () => navigate("/montacargas", { replace: true });
    window.addEventListener("montacargas-force-logout", handleForceLogout);
    return () => window.removeEventListener("montacargas-force-logout", handleForceLogout);
  }, [navigate]);

  return (
    <div className="montacargas-app">
      <Outlet />
    </div>
  );
}

export default MontacargasLayout;
